module.exports = __webpack_public_path__ + "img/cover-game-03.a2897930.jpg";